export const ENV_CONFIG = {
  "buildTimestamp": "2025-09-09T13:20:13+00:00",
  "shortSha": "496d595"
};